export default __webpack_public_path__ + "static/top-block-main-a57bc44ff4b4483bda844c4b633dabfa.png";